
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-privacy-policy",
      function () {
        return require("private-next-pages/prior-privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prior-privacy-policy"])
      });
    }
  